<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import type { Company } from '@gat-ship/types'
  import CompanyModalForm from '../modals/CompanyModalForm.vue'
  import CompanyModalDeactivate, {
    type DeactivateCompanyModalParams
  } from '../modals/CompanyModalDeactivate.vue'
  import CompanyModalReactivate, {
    type ActivateCompanyModalParams
  } from '../modals/CompanyModalReactivate.vue'
  import { companyModalsKey } from './company-modals'

  const modalCompanyFormRef = useTemplateRef('modalCompanyFormRef')
  const modalDeactivateCompanyRef = useTemplateRef('modalDeactivateCompanyRef')
  const modalReactivateCompanyRef = useTemplateRef('modalReactivateCompanyRef')

  const modals = {
    showAddCompany: () => {
      modalCompanyFormRef.value?.showAdd()
    },
    showEditCompany: (company: Company) => {
      modalCompanyFormRef.value?.showEdit(company)
    },
    showDeactivateCompany: (params: DeactivateCompanyModalParams) => {
      modalDeactivateCompanyRef.value?.showModal(params)
    },
    showReactivateCompany: (params: ActivateCompanyModalParams) => {
      modalReactivateCompanyRef.value?.showModal(params)
    }
  }

  provide(companyModalsKey, modals)

  defineExpose(modals)
</script>
<template>
  <slot />
  <CompanyModalForm ref="modalCompanyFormRef" />
  <CompanyModalDeactivate ref="modalDeactivateCompanyRef" />
  <CompanyModalReactivate ref="modalReactivateCompanyRef" />
</template>
